// removed by extract-text-webpack-plugin
module.exports = {"button":"_3PNMHbJE22xaFXrB596K3i"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SignInWithEpicButton.scss
// module id = 2594
// module chunks = 0